import fetchRetry from 'fetch-retry'

export const fetchWithRetry = fetchRetry(window.fetch, {
  retries: 3, // Number of retry attempts
  retryDelay: (attempt) => Math.pow(2, attempt) * 500, // 500, 1000, 2000
  retryOn: [500, 501, 502, 503, 504, 505, 507, 509, 510, 511, 520, 521, 522, 523, 524, 598, 599]
})
